import React from 'react';
import { Link } from 'react-router-dom';

const NotAllowed = () => {
    return (
        <div>
            <div style={styles.container}>
                <h1 style={styles.code}>403</h1>
                <p style={styles.text}>Access Denied</p>
                <p>You do not have permission to view this page.</p>
                <Link to="/" style={styles.link}>Click here to go back to Home.</Link>
            </div>
        </div>
    );
};

const styles = {
    container: {
        padding: '5rem',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
    },
    code: {
        fontSize: '6rem',
        color: '#b00020',
    },
    text: {
        fontSize: '1.5rem',
        marginBottom: '1rem',
    },
    link: {
        color: '#007bff',
        textDecoration: 'none',
    },
};

export default NotAllowed;